import { createApp } from 'vue';

import ApiTokenModal from './ApiTokenModal.vue';

const element = document.getElementById('api-token-modal');

if (element) {
  const jwtToken = element.getAttribute('data-jwt-token');
  const app = createApp(ApiTokenModal, {
    jwtToken,
  });
  app.mount(element);
}
